export default {
  SET_FLEXIFUND_DATA(state, flexiFundData) {
    state.flexiFund = flexiFundData;
  },
  SET_TEXTPAY_DATA(state, textPayData) {
    state.textPay = textPayData;
  },
  SET_QUICKSWAP_DATA(state, quickSwapData) {
    state.quickSwap = quickSwapData;
  },
  SET_SHAREGAIN_DATA(state, shareGainData) {
    state.shareGain = shareGainData;
  },
};
